import { CtLocale } from '@cointracker/graphql-types';

export const getLanguageFromLocale = (locale: CtLocale) => {
  switch (locale) {
    case CtLocale.DeDe:
      return 'de';
    case CtLocale.EnUs:
      return 'en';
    default:
      return 'en';
  }
};

export const getAvailableLanguages = () => {
  return Object.values(CtLocale).map(getLanguageFromLocale);
};

export const getLocaleFromLanguage = (language: string) => {
  switch (language) {
    case 'de':
      return CtLocale.DeDe;
    case 'en':
      return CtLocale.EnUs;
    default:
      return CtLocale.EnUs;
  }
};
